import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { navigationAction } from "../../../../context/actions/navigationAction";
import { rightsidebar, leftsidebarcicon, prevActiveId } from "../../../../context/actions/document";

import { documentType } from "../../../../utils/constants";

import { Button } from "reactstrap";
import "./index.scss";
import '../../../../assets/css/common/document/statusIcon.scss';
var _ = require('lodash');
const FileMenus = ({ sortFn, className = '', list, _handleSelectedAction }) => {

	if (!sortFn) {
		_.sortBy(list, 'createdAt');
		list.sort((a, b) => a.is_verified > b.is_verified ? -1 : 1).sort((a, b) => a.is_correct > b.is_correct ? -1 : 1);
	}

	// const liRef = useRef(null);
	const selectedFile = useSelector((state) => state.document.documentDataId);
	const rightSide = useSelector((state) => state.document.isOn);
	const leftSideCicon = useSelector((state) => state.document.cIcon);
	const files = useSelector((state) => state.document.docRecords)
	const folder = useSelector((state) => state.document.folder || null);
	const fileData = useSelector((state) => state.document.fileData);
	// const prevFileId = useSelector((state) => state.document.prevFileId);
	const dispatch = useDispatch();
	const [activeClickClass, setActiveClickClass] = useState(0);

	
	const __handleSelectedAction = (index, id) => {
	

		setActiveClickClass(0)
		dispatch(prevActiveId(activeId))
		_handleSelectedAction(id);
		setActiveId(id)
		dispatch(navigationAction(false));

	};



	const [activeId, setActiveId] = useState(selectedFile ? selectedFile : 0);

	//scrolls to the selected file for the first time when clicked on edit button from the documents page

	// useEffect(() => {
	// 	setTimeout(() => {
	// 		const el = document.querySelector('#scroll li.active');
	// 		if (document.querySelector('#scroll li.active')) {
	// 			const index = parseInt(document.querySelector('#scroll li.active').getAttribute('data-index'));
	// 			const elHeight = el.getBoundingClientRect().height;
	// 			const scrollHeight = document.querySelector('#scroll').getBoundingClientRect().height;
	// 			document.querySelector('#scroll').scrollTop = index * elHeight - scrollHeight;
	// 		}
	// 	}, 0)

	// }, []);

	useEffect(() => {

		setActiveId(selectedFile)
		//scrolls to the selected file for the first time when clicked on edit button from the documents page
		setTimeout(() => {
			const el = document.querySelector('#scroll li.active');
			if (document.querySelector('#scroll li.active')) {
				const index = parseInt(document.querySelector('#scroll li.active').getAttribute('data-index'));
				const elHeight = el.getBoundingClientRect().height;
				const scrollHeight = document.querySelector('#scroll').getBoundingClientRect().height;
				document.querySelector('#scroll').scrollTop = index * elHeight - scrollHeight;
			}
		}, 0)

	}, [selectedFile, list]);

	


	//comments => 
	//console.log('FILE ID PROP =>', liRef.current.dataset.fileid)


	return (
		<>
			{/*applied style in div controll the scrolling */}
			<div style={{ height: "100%", width: "100%", position: "relative", overflow: "hidden", overflowY: "auto" }} id="scroll">
				<ul className={`list-unstyled file-list  ${className}`}>
					{
						list.map((_val, index) => {
							return (
								<li key={_val._id} className={activeId === _val._id ? `active sort-type` : `sort-type`} data-toggle="tooltip" data-placement="top" data-index={index + 1} title={_val?.name} data-fileid={_val._id}>
									<Button onClick={() => __handleSelectedAction(index, _val._id)} color="link" className="text-start d-inline-flex align-items-center bg2">
										{_val?.reviewLabeled || _val?.complete ?
											<span className="transparent ">
												<svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M25.75 49.5C38.8668 49.5 49.5 38.8668 49.5 25.75C49.5 12.6332 38.8668 2 25.75 2C12.6332 2 2 12.6332 2 25.75C2 38.8668 12.6332 49.5 25.75 49.5Z" stroke="#92CD57" stroke-width="2.5" />
													<path d="M36.6834 19.344C37.0739 18.9535 37.7071 18.9535 38.0976 19.344C38.4881 19.7346 38.4881 20.3677 38.0976 20.7583L23.0642 35.7916C22.6737 36.1822 22.0405 36.1822 21.65 35.7916C21.2595 35.4011 21.2595 34.7679 21.65 34.3774L36.6834 19.344Z" fill="#92CD57" />
													<path d="M15.038 29.1793C14.6475 28.7888 14.6475 28.1556 15.038 27.7651C15.4285 27.3746 16.0617 27.3746 16.4522 27.7651L23.0636 34.3765C23.4541 34.767 23.4541 35.4002 23.0636 35.7907C22.6731 36.1812 22.0399 36.1812 21.6494 35.7907L15.038 29.1793Z" fill="#92CD57" />
												</svg>
											</span>
											: _val?.triage ? <span className="transparent blue_dot_badge">
											{/* <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
												<circle cx="15" cy="15" r="14.5" stroke="#ECD317" />
												<path fill-rule="evenodd" clip-rule="evenodd" d="M12.1156 4.90452H17.8844V10.1981L22.5577 7.71166L25.2674 12.8045L21.1236 15.0092L25.2607 17.2264L22.5357 22.3111L17.8844 19.8183V25.0955H12.1156V19.8019L7.44233 22.2883L4.73267 17.1955L8.87642 14.9908L4.7393 12.7736L7.46428 7.68894L12.1156 10.1817V4.90452Z" fill="#FF0000" />
											</svg> */}

											<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
												<g clip-path="url(#clip0_45_136)">
													<path d="M15 29.5C23.0081 29.5 29.5 23.0081 29.5 15C29.5 6.99187 23.0081 0.5 15 0.5C6.99187 0.5 0.5 6.99187 0.5 15C0.5 23.0081 6.99187 29.5 15 29.5Z" stroke="#ECD317" />
													<path fill-rule="evenodd" clip-rule="evenodd" d="M12.1158 4.90454H17.8846V10.1981L22.5579 7.71168L25.2676 12.8045L21.1238 15.0092L25.2609 17.2264L22.5359 22.3111L17.8846 19.8183V25.0955H12.1158V19.8019L7.44257 22.2883L4.73291 17.1955L8.87666 14.9908L4.73954 12.7736L7.46452 7.68896L12.1158 10.1817V4.90454Z" fill="#B71515" />
												</g>
												<defs>
													<clipPath id="clip0_45_136">
														<rect width="30" height="30" fill="white" />
													</clipPath>
												</defs>
											</svg>
											{_val?.assignedToFullName && _val?.assignedToFullName.length ? <span class="blue_badge">{_val?.assignedToFullName[0]?.fname.trim().charAt(0) + _val?.assignedToFullName[0]?.lname.trim().charAt(0) }</span> : null}
										</span> :
											<span className="icon d-inline-flex align-items-center justify-content-center rounded-circle">
												{_val?.name.charAt(0).toUpperCase()}
											</span>
										}
										<label >
											{_val?.name}
											{_val?.packet_type ? (<span className="user-lbl d-block">
												{_val?.packet_type?.type}
											</span>) : ''}
										</label>
										
									</Button>
								</li>
							)
						})
					}
				</ul>

			</div>
		</>);

}

export default FileMenus;